export { default } from './svg/panel.svg';
